var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatBubbleOvalLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/chat-bubble-oval-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 12C2.3999 7.24006 6.82797 3.59998 11.9999 3.59998C17.1718 3.59998 21.5999 7.24006 21.5999 12C21.5999 16.7599 17.1718 20.4 11.9999 20.4C11.3838 20.4 10.7805 20.3492 10.1953 20.2519C9.01403 21.1001 7.56434 21.6 5.9999 21.6C5.82274 21.6 5.64692 21.5936 5.47268 21.5809C5.15856 21.5582 4.87919 21.3728 4.73607 21.0923C4.59294 20.8117 4.60688 20.4768 4.77281 20.2091C5.15361 19.5948 5.38036 18.8753 5.39869 18.1018C3.57409 16.5903 2.3999 14.4293 2.3999 12Z",
    fill: "#C9C9C9",
    style: {
      mixBlendMode: "color-dodge"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleOvalLeft);
export default __webpack_public_path__ + "static/media/chat-bubble-oval-left.dfa11b197b9e5cd489e367f45dc1888e.svg";
export { ForwardRef as ReactComponent };